<nz-card nzTitle="Document Uploads"  >
    <p style="font-size:14px;color:rgba(0, 0, 0, 0.85);margin-bottom:16px;font-weight: 500;"></p>
    <nz-card nzType="inner" nzTitle="Upload Documents">
   
        <div class="row">
            <!-- Contract Duration  -->
            <div class="col">

        <nz-card>
            <p>
              
                <nz-upload [(nzFileList)]="fileList1" [nzBeforeUpload]="beforeUpload1" nzMultiple ="false">
                    <button type="button" class="btn btn-primary" ><i nz-icon nzType="upload"></i><span>Select Document</span></button>
                  </nz-upload>

            </p>
          </nz-card>

          <div class="col-md-4">
            <span class="upload" *ngIf="progress > 0">
              {{progress}}%
            </span>
            <span class="upload" *ngIf="message">
              {{message}}
            </span>
          </div>
          </div>
        </div>
          <div class="row">
            <!-- Contract Duration  -->
            <div class="col">
              <div class="form-group">
                <label for="exampleInputCity1">Description</label>
                <input type="text" class="form-control" id="Description" placeholder="medical"
                  name="Description" [(ngModel)]="Description" required  >
                
              </div>
            </div>
          </div>


          <button
            nz-button
            [nzType]="'primary'"
            [nzLoading]="uploading"
            (click)="handleUpload()"
            [disabled]="fileList1.length === 0"
            style="margin-top: 16px"
          >
          <i class="ti-upload btn-icon-prepend"></i>  
            {{ uploading ? 'Uploading' : 'Start Upload' }}
          </button>
    </nz-card>
    <nz-card nzType="inner" style="margin-top:16px;" nzTitle="Uploaded Documents" *ngIf="CanviewDocuments">
       
        <div class="card-body">
         
            <div class="table-responsive"  >
                
                <table class="table table--striped table-hover" class="clickable" >
                  <thead>
                    <tr>
    
                      <th>
                        Document Name
                      </th>
                      
                      <th>
                        Document Description
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let document of Documents"  (click)="openDoc(document.id)">
    
                      <td>{{document.documentName}}</td>
                      <td>{{document.documentDescription}}</td>
                    </tr>
                  </tbody>
                </table>
              </div> 
          </div>

    </nz-card>
  </nz-card>
  <ng-template #extraTemplate>
    <a>More</a>
  </ng-template>